import React from "react";
import { useNavigate } from "react-router-dom";

export const isFreePlan = (selectedTenant) =>
  String(selectedTenant?.data?.subscription_plan?.name || "").trim().toLowerCase() === "free";

/** "Feature Not Available" + Upgrade Plan (same block as the API Keys page). */
const FeatureNotAvailable = () => {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, textAlign: "center" }}>
      <h3 style={{ color: "#1a1a2e", fontWeight: 700, fontSize: 17, margin: 0 }}>Feature Not Available</h3>
      <p style={{ color: "#6b7280", fontSize: 13, maxWidth: 320, lineHeight: "1.8", margin: 0 }}>
        This feature is not available on your current plan.
        <br />
        Please upgrade your plan to unlock this feature.
      </p>
      <button
        className="save-btn"
        style={{ border: "none", backgroundColor: "#f75891", minWidth: "78px", height: "40px", fontWeight: "bold", fontSize: "14px", color: "#fff", borderRadius: "4px", padding: "0 12px" }}
        onClick={() => navigate("/plan")}
      >
        Upgrade Plan
      </button>
    </div>
  );
};

export default FeatureNotAvailable;
